import React from "react";
import {
    useAppSelector,
    useDispatchers,
} from "tsi-common-react/src/apps/reducers";
import {
    filteredStoreSelector,
    focusedStoreIDSelector,
} from "tsi-common-react/src/apps/retail/selectors";

import { LocatorNearestStores as LocatorNearestStoresComponent } from "../components/LocatorNearestStores";
import { Dispatchers } from "../dispatchers";

export const LocatorNearestStores = (): React.ReactNode => {
    const stores = useAppSelector(filteredStoreSelector);
    const focusedStoreID = useAppSelector(focusedStoreIDSelector);
    const filters = useAppSelector((state) => state.retail.storeFilters);
    const dispatchers = useDispatchers(Dispatchers);

    return (
        <LocatorNearestStoresComponent
            stores={stores}
            focusedStoreID={focusedStoreID}
            onSelectStore={dispatchers.setFocusedStore}
            showMore={filters.limit ? true : false}
        />
    );
};
